import { useCallback } from "react";

function useOnClick<T>(data: T, callback?: (data: T) => void) {
    const onClick = useCallback(() => callback && callback(data), [data, callback]);

    return callback ? onClick : undefined;
}

export default useOnClick;
